import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_snackbar, {
      value: _ctx.updateExists,
      left: "",
      bottom: "",
      timeout: -1,
      color: "primary"
    }, {
      default: _withCtx(() => [
        _createElementVNode("h3", null, [
          _cache[2] || (_cache[2] = _createTextVNode(" An update is available! ", -1)),
          _createVNode(_component_v_btn, {
            onClick: _ctx.refreshApp,
            class: "ml-4"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, null, {
                default: _withCtx(() => _cache[0] || (_cache[0] = [
                  _createTextVNode("refresh", -1)
                ])),
                _: 1,
                __: [0]
              }),
              _cache[1] || (_cache[1] = _createTextVNode(" Update ", -1))
            ]),
            _: 1,
            __: [1]
          }, 8, ["onClick"])
        ])
      ]),
      _: 1
    }, 8, ["value"])
  ]))
}